import React from 'react';
import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import Img from '../../Image/components/LazyImage';
import prevIcon from '../assets/prev.svg'
import nextIcon from '../assets/next.svg'
import { data as pages } from '../../PageNavigation/data/pages';

const StyledContainer = styled(Container)`
  background: ${props => props.backgroundColor};
  border-top: 1px solid #e5e5e5;
  padding: 0;
  font-size: 0.755rem;
  font-weight: 600;
  letter-spacing: 0.115rem;
  line-height: 1rem;
  text-transform: uppercase;
  a {
    color: #212529;
  }
  svg {
    width: 1.4rem;
  }
  img {
    display: none;
  }
  ${media.md`
    letter-spacing: 0.225rem;  
  `}
  ${media.lg`
    img {
      display: block;
    }
  `}
`;

const StyledRow = styled(Row)`
  margin: 0;
`;

const StyledCol = styled(Col)`
  display: flex;
  overflow: hidden;  
  svg {
    margin: 0.1rem 1rem 0;
  }
  ${media.sm`
    svg {
      margin: 0.2rem 2rem 0;
    }
  `}
  ${media.md`
    svg {
      margin: 0.2rem 3rem 0;
    }
  `}
  ${media.lg`
    svg {
      margin: 0.2rem 4.5rem 0;
    }
  `}
`;

const ColContent = styled.span`
  display: flex;
  align-items: center;
  margin: 2rem 0;
  ${media.md`
    margin: 3rem 0;
  `}
  ${media.lg`
    margin: 0;
    min-height: 150px;
    transition: 0.5s ease;
  `}
`;

const PrevCol = styled(StyledCol)`
  justify-content: flex-start;
  padding-left: 0;
  ${media.lg`
    a:hover > span {
      margin-left: 0;
    }
  `}
`;

const PrevContent = styled(ColContent)`
  ${(props) => props.prevImage && media.lg`
    margin-left: -300px;
  `}
`;

const NextCol = styled(StyledCol)`
  justify-content: flex-end;
  padding-right: 0;
  ${media.lg`
    a:hover > span {
      margin-right: 0;
    }
  `}
`;
const NextContent = styled(ColContent)`
  text-align: right;
  ${(props) => props.nextImage && media.lg`
    margin-right: -300px;
  `}
`;

const PageNavigation = (props) => {
  const { prev, next, backgroundColor } = props;
  const prevPage = pages[prev];
  const nextPage = pages[next];
  const bgColor = (backgroundColor) ? backgroundColor : "none";

  return <StyledContainer backgroundColor={bgColor} fluid>
    <StyledRow>
      <PrevCol col={6}>
        {prevPage && prevPage.url && prevPage.title &&
          <Link to={prevPage.url}>
            <PrevContent prevImage={prevPage.image}>
              {prevPage.image && <Img src={require(`../assets/${prevPage.image}`)} alt={prevPage.title} />}
              <SVG src={prevIcon} />
              <span>{prevPage.title}</span>
            </PrevContent>
          </Link>
        }
      </PrevCol>
      <NextCol col={6}>
        {nextPage && nextPage.url && nextPage.title &&
          <Link to={nextPage.url}>
            <NextContent nextImage={nextPage.image}>
              <span>{nextPage.title}</span>
              <SVG src={nextIcon} />
              {nextPage.image && <Img src={require(`../assets/${nextPage.image}`)} alt={nextPage.title} />}
            </NextContent>
          </Link>
        }
      </NextCol>
    </StyledRow>
  </StyledContainer>;
};

export default PageNavigation;
